import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';

import VideoConferenceResource from 'flow/api/videoconference';
import { MeetingsDTO } from 'flow/types/Meetings';

export const TODAY_MEETINGS_QUERY_KEY = ['todayMeetings'];

// from/to omitted: the backend defaults the window to today in the given zone.
const fetchTodayMeetings = (timeZone: string): Promise<MeetingsDTO> =>
    new Promise((resolve, reject) => {
        VideoConferenceResource.getMeetings(
            {
                onResult: resolve,
                onError: reject,
            },
            timeZone,
        );
    });

export const useTodayMeetings = (enabled = true) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return useAuthenticatedQuery({
        queryKey: [...TODAY_MEETINGS_QUERY_KEY, timeZone],
        queryFn: () => fetchTodayMeetings(timeZone),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        enabled,
    });
};
